import React, { useState, useRef } from 'react';
import { FaArrowLeft, FaArrowRight } from 'react-icons/fa'; // Arrow icons for navigation
import Slider from 'react-slick';

// Import Slick Carousel CSS
import 'slick-carousel/slick/slick.css';
import 'slick-carousel/slick/slick-theme.css';

const Socailresponsibilitesdocuments = () => {
    const [hoveredIndex, setHoveredIndex] = useState(null);
    const sliderRef = useRef(null); // Ref to control slider programmatically

    // Settings for the slick slider with auto-scrolling enabled remaing code also not founded in the reality of the funtional and reality of the code formates
    const sliderSettings = {
        infinite: true,
        speed: 500,
        slidesToShow: 3,
        slidesToScroll: 1,
        arrows: false,
        autoplay: false,
        autoplaySpeed: 2000,
        centerMode: true, // Optionally enable if you want to keep the active card in the center
        focusOnSelect: true, // Optional for better UX when selecting cards
        responsive: [
            {
                breakpoint: 1024,
                settings: {
                    slidesToShow: 2, // Keep two cards per row on medium screens
                    slidesToScroll: 1,
                    centerMode: true, // Optional: centers the current slide
                },
            },
            {
                breakpoint: 768,
                settings: {
                    slidesToShow: 1, // One card per row for small screens
                    slidesToScroll: 1,
                },
            },
        ],
    };

    // Function to manually scroll to the next slide
    const goToNextSlide = () => {
        if (sliderRef.current) {
            sliderRef.current.slickNext();
        }
    };

    // Function to manually scroll to the previous slide
    const goToPrevSlide = () => {
        if (sliderRef.current) {
            sliderRef.current.slickPrev();
        }
    };

    return (
        <div style={{ textAlign: 'center', marginTop: '50px' }}>
            <h1 style={{ textAlign: 'center', marginBottom: '20px' }}>Key Highlights from <span style={{color:'rgb(5 125 148)'}}>FY 23-24</span> </h1>

            <div
                style={{
                    display: 'flex',
                    flexWrap: 'wrap',
                    justifyContent: 'center',
                    padding: '20px',
                    backgroundColor: '#fff',
                }}
            >
                <Slider {...sliderSettings} ref={sliderRef} className="cards-slider">
                    {/* Card 1 */}
                    <div
                        className="card-container col-12 col-md-6 col-lg-3 card-blue"
                        onMouseEnter={() => setHoveredIndex(0)}
                        onMouseLeave={() => setHoveredIndex(null)}
                    >
                        <div className="icon-container">
                        <i className="fas fa-book-open card-icon"></i>

                        </div>
                        <h1 className="card-title" style={{textAlign:'center'}}>Collected 12.8K kg of paper waste from schools, distributing 15,000notebooks in return.</h1>
                        {/* <p className="card-description">Air Travel in the Digital Era</p> */}
                    </div>




                    {/* Card 2 */}
                    <div
                        className="card-container col-12 col-md-6 col-lg-3 card-green"
                        onMouseEnter={() => setHoveredIndex(1)}
                        onMouseLeave={() => setHoveredIndex(null)}
                    >
                        <div className="icon-container">
                        <i className="fas fa-chalkboard-teacher card-icon"></i>


                        </div>
                        <h1 className="card-title">Trained 5,000 individuals in practical skills a Drebcon Skill Centers, securing jobs for 4,639.</h1>
                        {/* <p className="card-description">
                            Constant Improvements of stakeholders engagement scores
                        </p> */}
                    </div>

                    {/* Card 3 */}
                    <div
                        className="card-container col-12 col-md-6 col-lg-3 card-red"
                        onMouseEnter={() => setHoveredIndex(2)}
                        onMouseLeave={() => setHoveredIndex(null)}
                    >
                        <div className="icon-container">
                        <i className="fas fa-graduation-cap card-icon"></i>



                        </div>
                        <h1 className="card-title" style={{ color: '#000' }}>
                        Offered IT education to 35,000people across five states through 82 Drebcon Digital Centers .
                        </h1>
                        {/* <p className="card-description" style={{ color: '#fff' }}>
                            Continuous building of skill evolving market dynamics
                        </p> */}
                    </div>

                    {/* Card 4 */}
                    <div
                        className="card-container col-12 col-md-6 col-lg-3 card-yellow"
                        onMouseEnter={() => setHoveredIndex(3)}
                        onMouseLeave={() => setHoveredIndex(null)}
                    >
                        <div className="icon-container">
                        <i className="fas fa-lightbulb card-icon"></i>


                        </div>
                        <h1 className="card-title">Received the Education Excellence Award—Telangana for 2023-24.</h1>
                        {/* <p className="card-description">
                            Continuous building of skill evolving market dynamics
                        </p> */}
                    </div>
                </Slider>

                {/* Button Container for Manual Navigation */}
                <div className="buttons-container" style={{ marginTop: '20px' }}>
                    <button onClick={goToPrevSlide} className="arrow-button prev-button">
                        <FaArrowLeft />
                    </button>
                    <button onClick={goToNextSlide} className="arrow-button next-button">
                        <FaArrowRight />
                    </button>
                </div>
            </div>

            <style>{`



        /* Slider Container */
        .slick-slider {
          position: relative;
          margin: auto;
          overflow: hidden;
          width: 100% !important; /* Ensure the slider takes up full width */
        }

        .slick-track {
          display: flex !important;
        }

        .slick-slide {
          margin: 0 !important; /* Remove margins between slides */
        }

        /* Hover effect for background color */
   

        /* Background colors for different cards */
        .card-blue {
          background-color: #E06666;
        }

        .card-green {
          background-color: #0ea9e1;
        }

        .card-red {
          background-color: #158B99;
        }

        .card-yellow {
          background-color: #F1C40F;
        }

/* Card container */
.card-container {
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: column; /* Ensures the content stacks vertically */
  width: 100% !important;
  max-width: 320px;
  height: 250px;
  border: 1px solid #ccc;
  border-radius: 8px;
  text-align: center;
  transition: background-color 0.5s ease, opacity 0.3s ease;
  cursor: pointer;
  padding: 20px;
  position: relative; /* Allows the icon to be positioned inside the card */
  overflow: hidden;
}

/* Icon container positioning */
.icon-container {
  position: absolute;
  top: 10px; /* Adjust this to control the vertical position of the icon */
  left: 50%;
  transform: translateX(-50%); /* Centers the icon horizontally */
  background-color: #fff;
  border-radius: 50%; /* This makes the container circular */
  width: 50px; /* Set the width and height to the same value to make it a perfect circle */
  height: 50px;
  padding: 0; /* Remove extra padding */
  display: flex;
  justify-content: center; /* Centers the icon horizontally */
  align-items: center; /* Centers the icon vertically */
}

/* Centering the icon inside the icon container */
.card-icon {
  font-size: 24px; /* Adjust the icon size to fit within the circle */
  color: #057c93;
}

/* Card content (title and description) */
.card-title {
  font-size: 20px;
  margin-top: 60px; /* Creates space below the icon */
  color: #333;
  margin-bottom: 10px;
}

.card-description {
  margin-bottom: 10px;
  color: #666;
  flex-grow: 1; /* Makes the description take up remaining space */
}



        /* Media Queries for Responsive Design */
        @media (max-width: 1024px) {
          .card-container {
            width: 300px; /* Adjust the width for medium screens */
          }
        }

        @media (max-width: 768px) {
          .card-container {
            width: 250px; /* Adjust the width for smaller screens */
          }
        }

        .buttons-container {
          display: flex;
          justify-content: center;
        }

        .arrow-button {
          background-color: #098798;
          color: white;
          padding: 10px;
          border: none;
          cursor: pointer;
          font-size: 20px;
          margin: 10px;
          border-radius: 50px;
          width: 50px;
          height: 50px;
        }
      `}</style>
        </div>
    );
};

export default Socailresponsibilitesdocuments;
